import React, { useEffect, useState } from "react";
import DaumPostcodeEmbed from "react-daum-postcode";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import promotionApi from "../../../apis/Promotion.api";
import pushApi from "../../../apis/Push.api";
import salesManageApi from "../../../apis/SalesManage.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import OrderDetailComponent from "./OrderDetailComponent";
import ExcelUploadBody from "./OrderSearch/excelUpload/excelUploadBody";
import SearchQuickMenu from "./OrderSearch/SearchQuickMenu";

const OrderSearchComponent = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [mediaResult, setMediaResult] = useState(null);
  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "payment_created_at",
    searchStatus: "paid",
    searchDetailType: "",
    searchDetail: "",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0,
    name: "",
    phone: "",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("payment_created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([]);
  const [totalOrderList, setTotalOrderList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [editDeliveryInfo, setEditDeliveryInfo] = useState({});
  const [customerDeliveryInfo, setCustomerDeliveryInfo] = useState({});
  const [editCancelReason, setEditCancelReason] = useState({
    cancel_reason: null,
    refund_bank: null,
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false);
  const [isDeliveryShippingModalOpen, setIsDeliveryShippingModalOpen] =
    useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isCancelRequestModalOpen, setIsCancelRequestModalOpen] =
    useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [validation, setValidation] = useState(false);
  const [uploadExcelDataHeader, setUploadExcelDataHeader] = useState([]);
  const [uploadExcelData, setUploadExcelData] = useState([]);
  const [uploadExcelDataError, setUploadExcelDataError] = useState([]);
  const [uploadExcelName, setUploadExcelName] = useState("");
  const [error, setError] = useState("");

  const searchDateItems = [
    { searchText: "결제일", searchType: "payment_created_at" },
    { searchText: "발송일", searchType: "ship_date" },
    { searchText: "주문일시", searchType: "order_created_at" },
    { searchText: "구매확정일", searchType: "complete_date" },
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const orderStatusItems = [
    { label: "전체", value: "total" },
    // {label: '입금대기', value: 'ready'},
    { label: "입금완료", value: "paid" },
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    { label: "배송준비중", value: "delivery_ready" },
    { label: "배송중", value: "delivery_shipping" },
    { label: "배송완료", value: "delivery_complete" },
    { label: "구매확정", value: "complete" },
    { label: "취소요청", value: "cancel_request" },
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    { label: "취소완료", value: "cancel_complete" },
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ];
  const funnelStatusItems = [
    { label: "전체", value: 0 },
    { label: "검색", value: 1 },
    { label: "전화주문", value: 4 },
    { label: "인플루언서", value: 2 },
    { label: "셀러", value: 5 },
    { label: "공동구매", value: 3 },
  ];
  const cancelReasonItems = [
    { label: "상품품절", value: "상품품절" },
    { label: "배송지연", value: "배송지연" },
    { label: "서비스 불만족", value: "서비스 불만족" },
    { label: "구매의사취소", value: "구매의사취소" },
    { label: "색상 및 사이즈 변경", value: "색상 및 사이즈 변경" },
    { label: "다른 상품 잘못 주문", value: "다른 상품 잘못 주문" },
    { label: "상품정보 상이", value: "상품정보 상이" },
  ];
  const bankCodeItems = [
    { label: "KB국민은행", value: "04" },
    { label: "SC제일은행", value: "23" },
    { label: "경남은행", value: "39" },
    { label: "광주은행", value: "34" },
    { label: "기업은행", value: "03" },
    { label: "농협", value: "11" },
    { label: "대구은행", value: "31" },
    { label: "부산은행", value: "32" },
    { label: "산업은행", value: "02" },
    { label: "새마을금고", value: "45" },
    { label: "수협", value: "07" },
    { label: "신한은행", value: "88" },
    { label: "신협", value: "48" },
    { label: "외환은행", value: "81" },
    { label: "우리은행", value: "20" },
    { label: "우체국", value: "71" },
    { label: "전북은행", value: "37" },
    { label: "축협", value: "12" },
    { label: "카카오뱅크", value: "90" },
    { label: "케이뱅크", value: "89" },
    { label: "하나은행", value: "81" },
    { label: "한국씨티은행", value: "27" },
    { label: "토스뱅크", value: "92" },
  ];
  const orderPair = {
    payment_created_at: "결제일순",
    order_id: "주문번호순",
    // ship_date: '발송일순',
    created_at: "주문일시순",
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      for (const row of selectedRows) {
        if (!editDeliveryInfo.hasOwnProperty(row.order_detail_id)) {
          editDeliveryInfo[row.order_detail_id] = {
            order_id: row.order_id,
            order_detail_id: row.order_detail_id,
            order_detail_status: "delivery_shipping",
            delivery_company: row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date:
              row.ship_date === null || row.ship_date === ""
                ? moment()
                : moment(row.ship_date),
            updated_by: user.id === 724 ? 1 : user.id,
          };
        }
      }
      let difference = Object.keys(editDeliveryInfo).filter(
        (orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey)),
      );
      if (difference?.length !== 0) {
        for (const orderDetailKey of difference) {
          delete editDeliveryInfo[orderDetailKey];
        }
      }
      setSelectedRowKey(selectedRowKeys);
      setSelectedRow(selectedRows);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 80,
      fixed: mediaResult ? "" : "left",
      dataIndex: "order_id",
      key: "order_id",
      ellipsis: true,
      align: "right",
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "상품주문번호",
      width: 90,
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      align: "right",
      // sorter: (a, b) => {},
      // render: (value, record) => {
      //     return <span
      //         className="recommend-inquiry-list-title"
      //         onClick={() => {
      //             setOrderDetail(record)
      //             setIsOrderModalOpen(true)
      //         }}
      //     >{value}</span>
      // }
    },
    // {
    //     title: '주문일시',
    //     width: 160,
    //     dataIndex: 'created_at',
    //     key: 'created_at',
    //     ellipsis: true,
    //     sorter: (a, b) => {
    //     },
    //     render: (value) => {
    //         if (value !== null) {
    //             const date = moment(value).format("YYYY.MM.DD. HH:mm")
    //             return date
    //         }
    //     }
    // },
    {
      title: "결제일",
      width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "구매확정일",
      width: 160,
      dataIndex: "complete_date",
      key: "complete_date",
      ellipsis: true,
      // sorter: (a, b) => {
      // },
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "상품번호",
      // width: 200,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
      align: "right",
    },
    {
      title: "상품명",
      width: 180,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
    },
    {
      title: "수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      align: "right",
    },
    {
      title: "상품별 총 주문금액",
      // width: 150,
      dataIndex: "total_price",
      key: "total_price",
      ellipsis: true,
      align: "right",
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "주문상태",
      width: 90,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      render: (value) => {
        return status.orderStatusChange(value);
      },
    },
    {
      title: `당영 관리 수수료`,
      // width: 200,
      dataIndex: "brand_fee_rate",
      key: "brand_fee_rate",
      ellipsis: true,
      align: "right",
      render: (value, record) => {
        if (
          record.order_detail_status !== "ready" &&
          record.order_detail_status !== "cancel_request" &&
          record.order_detail_status !== "return_request" &&
          record.order_detail_status !== "return_receive" &&
          record.order_detail_status !== "return_collection" &&
          record.order_detail_status !== "return_collection_complete" &&
          record.order_detail_status !== "cancel_complete" &&
          record.order_detail_status !== "return_complete"
        ) {
          if (!record.is_cooperate) {
            return "-" + Math.round(record.total_price * 0.11).toLocaleString();
          } else {
            // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
            if (record.dy_commission_include) {
              return (
                "-" + Math.floor(record.total_price * 0.11).toLocaleString()
              );
            } else {
              return 0;
            }
          }
        } else {
          return 0;
        }
      },
    },
    {
      title: `매출 연동 수수료`,
      // width: 200,
      dataIndex: "",
      key: "",
      ellipsis: true,
      align: "right",
      render: (value, record) => {
        if (
          record.order_detail_status !== "ready" &&
          record.order_detail_status !== "cancel_request" &&
          record.order_detail_status !== "return_request" &&
          record.order_detail_status !== "return_receive" &&
          record.order_detail_status !== "return_collection" &&
          record.order_detail_status !== "return_collection_complete" &&
          record.order_detail_status !== "cancel_complete" &&
          record.order_detail_status !== "return_complete"
        ) {
          if (value.query) {
            if (record.is_cooperate) {
              return record.total_price *
                ((record.cooperate_fee_rate * 1.1) / 100) ===
                0
                ? 0
                : "-" +
                    Math.round(
                      record.total_price *
                        ((record.cooperate_fee_rate * 1.1) / 100),
                    ).toLocaleString();
            } else {
              return record.total_price *
                ((record.commission_rate * 1.1) / 100) ===
                0
                ? 0
                : "-" +
                    Math.round(
                      record.total_price *
                        ((record.commission_rate * 1.1) / 100),
                    ).toLocaleString();
            }
          } else {
            return 0;
          }
          // if (record.is_cooperate) {
          //     return "-" + Math.round(record.total_price * ((record.cooperate_fee_rate * 1.1) / 100)).toLocaleString()
          // } else if (record.is_influencer) {
          //     return "-" + Math.round(record.total_price * (record.influencer_fee_rate / 100)).toLocaleString()
          // } else {
          //     return 0
          // }
        } else {
          return 0;
        }
      },
    },
    {
      title: "구매 경로",
      // width: 200,
      dataIndex: "",
      key: "",
      ellipsis: true,
      align: "center",
      render: (value, record) => {
        let path = "";
        if (value.query) {
          if (record.is_cooperate) {
            path = "공동구매";
          } else {
            if (record?.is_manual) {
              path = "전화주문-";
            }
            if (
              record?.influencer_role === "super_admin" ||
              record?.influencer_role === "level_1"
            ) {
              path += "인플루언서";
            } else {
              path += "셀러";
            }
          }
        } else if (record?.is_manual) {
          path = "전화주문";
        } else {
          path = "검색";
        }
        return path;
      },
    },
    {
      title: "택배사",
      width: 180,
      dataIndex: "delivery_company",
      key: "delivery_company",
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_ready" ||
          record.order_detail_status === "delivery_shipping"
        ) {
          if (selectedRowKey.includes(record.order_detail_id)) {
            return (
              <Select
                className="order-delivery-company-select"
                placeholder="선택"
                value={
                  editDeliveryInfo[record.order_detail_id].delivery_company
                }
                onChange={(value, e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.id]: {
                      ...editDeliveryInfo[e.id],
                      delivery_company: value,
                    },
                  })
                }
              >
                {deliveryCompanyList.map((deliveryCompany, idx) => (
                  <Option
                    key={`delivery_company_select_${idx}`}
                    id={record.order_detail_id}
                    value={deliveryCompany.delivery_company_id}
                  >
                    {deliveryCompany.delivery_company_name}
                  </Option>
                ))}
              </Select>
            );
          } else {
            if (value === null || value === "") {
              return value;
            } else {
              const findDeliveryCompany = deliveryCompanyList.find(
                (deliveryCompany) =>
                  deliveryCompany.delivery_company_id === value,
              );
              if (findDeliveryCompany) {
                return findDeliveryCompany.delivery_company_name;
              } else {
                return value;
              }
            }
          }
        } else {
          if (value === null || value === "") {
            return value;
          } else {
            const findDeliveryCompany = deliveryCompanyList.find(
              (deliveryCompany) =>
                deliveryCompany.delivery_company_id === value,
            );
            if (findDeliveryCompany) {
              return findDeliveryCompany.delivery_company_name;
            } else {
              return value;
            }
          }
        }
      },
    },
    {
      title: "송장번호",
      width: 200,
      dataIndex: "tracking_number",
      key: "tracking_number",
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_ready" ||
          record.order_detail_status === "delivery_shipping"
        ) {
          if (selectedRowKey.includes(record.order_detail_id)) {
            return (
              <Input
                className="order-tracking-number-input"
                name={record.order_detail_id}
                value={editDeliveryInfo[record.order_detail_id].tracking_number}
                onChange={(e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.target.name]: {
                      ...editDeliveryInfo[e.target.name],
                      tracking_number: e.target.value,
                    },
                  })
                }
              />
            );
          } else {
            return value;
          }
        } else {
          return value;
        }
      },
    },
    {
      title: "발송일",
      width: 160,
      dataIndex: "ship_date",
      key: "ship_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (
          record.order_detail_status === "delivery_ready" ||
          record.order_detail_status === "delivery_shipping"
        ) {
          if (selectedRowKey.includes(record.order_detail_id)) {
            return (
              <DatePicker
                className="order-ship-date-input"
                format="YYYY-MM-DD"
                value={editDeliveryInfo[record.order_detail_id].ship_date}
                onChange={(value) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [record.order_detail_id]: {
                      ...editDeliveryInfo[record.order_detail_id],
                      ship_date: value,
                    },
                  })
                }
              />
            );
          } else {
            if (value === null || value === "") {
              return value;
            } else {
              const date = moment(value).format("YYYY.MM.DD");
              return date;
            }
          }
        } else {
          if (value === null || value === "") {
            return value;
          } else {
            const date = moment(value).format("YYYY.MM.DD");
            return date;
          }
        }
      },
    },
    {
      title: "수취인명",
      width: 90,
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      render: (value, row) => {
        // 	let name = value?.trim().replace(" ", "");
        // 	if (row.order_detail_id === 20429) {
        // 		console.log(row);
        // 	}
        // 	return name;
        // },
        if (row.is_gift) {
          if (row.gift_to_name) {
            return row.gift_to_name;
          }
        } else {
          if (value) {
            return value;
          }
        }
      },
    },
    {
      title: "구매자명",
      width: 90,
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      render: (value, row) => {
        if (row.is_gift) {
          return row.gift_from_name;
        } else {
          if (value) {
            let name = value?.trim().replace(" ", "");
            if (name?.length < 3) {
              return name?.slice(0, 1) + "*";
            } else {
              return name?.slice(0, 1) + "*" + name?.charAt(name?.length - 1);
            }
            // return value;
          } else {
            return null;
          }
        }
      },
    },
    {
      title: "연락처",
      // width: 90,
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "주소",
      // width: 90,
      dataIndex: "address",
      key: "address",
      ellipsis: true,
    },
    {
      title: "상세주소",
      // width: 90,
      dataIndex: "address_detail",
      key: "address_detail",
      ellipsis: true,
    },
    {
      title: `정산 금액`,
      // width: 200,
      dataIndex: "",
      key: "",
      ellipsis: true,
      align: "right",
      render: (value, record) => {
        if (
          record.order_detail_status !== "ready" &&
          record.order_detail_status !== "cancel_request" &&
          record.order_detail_status !== "return_request" &&
          record.order_detail_status !== "return_receive" &&
          record.order_detail_status !== "return_collection" &&
          record.order_detail_status !== "return_collection_complete" &&
          record.order_detail_status !== "cancel_complete" &&
          record.order_detail_status !== "return_complete"
        ) {
          let returnPrice = record.total_price;
          if (record.query) {
            if (record.is_cooperate) {
              returnPrice =
                returnPrice -
                Math.round(
                  record.total_price *
                    ((record.cooperate_fee_rate * 1.1) / 100),
                );
              // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
              if (record.dy_commission_include) {
                returnPrice -= Math.floor(record.total_price * 0.11);
              }
            } else {
              returnPrice =
                returnPrice -
                Math.round(
                  record.total_price * ((record.commission_rate * 1.1) / 100),
                );
              returnPrice = returnPrice - Math.round(record.total_price * 0.11);
            }
          } else {
            returnPrice = returnPrice - Math.round(record.total_price * 0.11);
          }
          return returnPrice.toLocaleString() + "원";
        } else {
          return 0;
        }
      },
    },
  ];

  const [propsType, setPropsType] = useState(false);
  // const [oneTime, setOneTime] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);
      // if (!matchQueryList.matches) {
      //     setMobileColumn(false);
      // }

      const media = function handleChange(e) {
        setMediaResult(e.matches);
        // if (!e.matches) {
        //     setMobileColumn(false);
        // }
      };

      matchQueryList.addEventListener("change", media);
    }
  }, []);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  useEffect(() => {
    if (propsType) {
      getUserOrderList();
    }
  }, [orderType, orderBy]);

  useEffect(() => {
    let type = props.location.search?.split("?type=")[1];
    if (!propsType) {
      setIsLoading(true);
      if (type) {
        setSearchOptions({
          ...searchOptions,
          startDate: moment().subtract(14, "d"),
          searchStatus: type,
        });
        setDateType("");
        setPropsType(true);
        getUserOrderListType(type);
      } else {
        getUserOrderList("initial");
        setPropsType(true);
      }
      getDeliveryCompanyList();
    }
  }, [props, propsType, orderType, orderBy]);

  const getUserOrderListType = async (type) => {
    const res = await salesManageApi.searchOrderDetailList(
      0,
      10,
      "order",
      searchDateItems[0].searchType,
      moment().subtract(14, "d").startOf("day").format("YYYYMMDDHHmm"),
      moment().endOf("day").endOf("day").format("YYYYMMDDHHmm"),
      type,
      "",
      "",
      0,
      "",
      "",
      "payment_created_at",
      "desc",
      "",
      "",
      user.id === 724 ? 1 : user.id,
    );
    if (res.code === 200) {
      if (res.result.userOrderDetailDTOList?.length > 1) {
        if (orderType === "created_at") {
          if (orderBy === "desc") {
            res.result.userOrderDetailDTOList.sort(
              (a, b) => moment(b.created_at) - moment(a.created_at),
            );
          } else {
            res.result.userOrderDetailDTOList.sort(
              (a, b) => moment(a.created_at) - moment(b.created_at),
            );
          }
        }
      }
      setTotalOrderList(res.result.userOrderDetailDTOList);
      setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
      if (res.result?.length !== 0) {
        setTotalSize(res.result.totalCnt);
      }
    }
    setIsLoading(false);
  };

  const getDeliveryCompanyList = async () => {
    setIsLoading(true);
    try {
      const res = await salesManageApi.deliveryCompanyList("delivery_tracker");
      if (res.code === 200) {
        setDeliveryCompanyList(res.result);
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getDeliveryCompanyList read error", error);
    }
  };

  const getUserOrderList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "order",
          searchDateItems[0].searchType,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          orderStatusItems[1].value,
          "",
          "",
          0,
          "",
          "",
          "payment_created_at",
          "desc",
          "",
          "",
          user.id === 724 ? 1 : user.id,
          "",
        );
      } else if (type === "search") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "order",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "order",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        if (res.result.userOrderDetailDTOList?.length > 1) {
          if (orderType === "created_at") {
            if (orderBy === "desc") {
              res.result.userOrderDetailDTOList.sort(
                (a, b) => moment(b.created_at) - moment(a.created_at),
              );
            } else {
              res.result.userOrderDetailDTOList.sort(
                (a, b) => moment(a.created_at) - moment(b.created_at),
              );
            }
          }
        }
        setTotalOrderList(res.result.userOrderDetailDTOList);
        if (type === "initial" || type === "search") {
          setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
        } else {
          setOrderList(
            res.result.userOrderDetailDTOList.slice(offset, offset + pageSize),
          );
        }
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getUserOrderList read error", error);
    }
  };

  const changeOrderStatus = async (orderStatus) => {
    setIsLoading(true);
    try {
      let res;
      if (orderStatus === "delivery_shipping") {
        const result = deliveryInfoValidation();
        if (result) {
          const param = {
            userOrderDetailDTOList: Object.values(editDeliveryInfo),
          };
          res = await salesManageApi.orderTrackingNumRegister(param);
        } else {
          alert("배송지 및 송장번호를 입력하지 않는 항목이 있습니다.");
          throw "not valid";
        }
      } else {
        const orderIdSet = new Set(
          selectedRow.map((selectedRow) => selectedRow.order_id),
        );
        const editOrderList = {
          orderIdList: [...orderIdSet],
          orderDetailIdList: selectedRowKey,
          order_status: orderStatus,
          updated_by: user.id === 724 ? 1 : user.id,
        };
        res = await salesManageApi.orderStatusEdit(editOrderList);
      }
      if (res.code === 200) {
        if (orderStatus === "delivery_shipping") {
          const orderIdSet = new Set(
            Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.order_id,
            ),
          );
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.order_detail_id,
            ),
            order_status: orderStatus,
          };
          await sendKakaoAlert(orderParam);
        }
        alert("해당 내용이 성공적으로 반영되었습니다.");
        setSelectedRowKey([]);
        setSelectedRow([]);
        getUserOrderList();
      } else if (res.code === 999 || res.code === 405) {
        alert(res.msg);
      } else {
        alert(
          "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("changeOrderStatus edit error", error);
    }
  };

  const editCustomerDeliveryInfo = async () => {
    setIsLoading(true);
    try {
      const param = {
        ...customerDeliveryInfo,
        updated_by: user.id === 724 ? 1 : user.id,
      };
      const res = await salesManageApi.orderDeliveryInfoEdit(param);
      if (res.code === 200) {
        alert("해당 내용이 성공적으로 반영되었습니다.");
      } else if (res.code === 999) {
        alert(res.msg);
      } else {
        alert(
          "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("editCustomerDeliveryInfo edit error", error);
    }
  };

  /**
   * 배송 시작 안내 알림톡 보내기
   */
  const sendKakaoAlert = async (orderParam) => {
    try {
      const res = await pushApi.kakaoForDelivery(orderParam);
      if (res.code !== 200) {
        alert(
          "선택한 주문건들에 대해 카카오알림톡을 보내는데 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.",
        );
      } else {
        console.log("sendKakaoAlert success", res.result);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("sendKakaoAlert alert error", error);
    }
  };

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      setIsLoading(true);
      let excelData;
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          // 당영 관리 수수료
          let commission_dy = row.is_cooperate
            ? row?.dy_commission_include
              ? Math.floor(row.total_price * 0.11)
              : 0
            : Math.round(row.total_price * 0.11);
          // 매출 연동 수수료
          let commission_sell = row.query
            ? row.is_cooperate
              ? Math.round(
                  row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
                )
              : Math.round(
                  row.total_price * ((row.commission_rate * 1.1) / 100),
                )
            : 0;

          // row.is_influencer
          //     ? Math.round(row.total_price * (row.influencer_fee_rate / 100)) : 0
          // 예상 수익
          let profit_price = row.total_price;
          if (row.query) {
            if (row.is_cooperate) {
              profit_price =
                profit_price -
                Math.round(
                  row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
                );
              if (row?.dy_commission_include) {
                profit_price -= Math.floor(row.total_price * 0.11);
              }
            } else {
              profit_price =
                profit_price -
                Math.round(
                  row.total_price * ((row.commission_rate * 1.1) / 100),
                );
              profit_price = profit_price - Math.round(row.total_price * 0.11);
            }
          } else {
            profit_price = profit_price - Math.round(row.total_price * 0.11);
          }
          let purchase_path = "";
          if (row.query) {
            if (row.is_cooperate) {
              purchase_path = "공동구매";
            } else {
              if (row?.is_manual) {
                purchase_path = "전화주문-";
              }
              if (
                row?.influencer_role === "super_admin" ||
                row?.influencer_role === "level_1"
              ) {
                purchase_path += "인플루언서";
              } else {
                purchase_path += "셀러";
              }
            }
          } else if (row?.is_manual) {
            purchase_path = "전화주문";
          } else {
            purchase_path = "검색";
          }
          if (user && (user.id === 1 || user.id === 724)) {
            return {
              order_id: `DY${row.order_id}`,
              order_detail_id: `dy${row.order_detail_id}`,
              payment_created_at: moment(row.payment_created_at).format(
                "YYYY.MM.DD HH:mm",
              ),
              order_detail_status:
                status.matchingOrderStatus[row.order_detail_status],
              product_id: row.product_id,
              product_name: row.product_name,
              option_id: row.option_id,
              option_title: row.option_title,
              quantity: row.quantity,
              total_price: row.total_price,
              price: row.price,
              coupon_discount_price: row.coupon_discount_price,
              created_by_name: row.created_by_name,
              use_point: row.use_point ? "Y" : "N",
              name: row.name,
              phone: row.phone,
              address: row.address
                ? row.address +
                  (row.address_detail ? `, ${row.address_detail}` : "")
                : "",
              address_request:
                row.address_request === "배송 시 요청사항을 선택해주세요."
                  ? ""
                  : row.address_request,
              delivery_company: status.matchingDeliveryCompany[
                row.delivery_company
              ]
                ? status.matchingDeliveryCompany[row.delivery_company]
                : row.delivery_company,
              tracking_number: row.tracking_number,
              ship_date: row.ship_date
                ? moment(row.ship_date).format("YYYY.MM.DD")
                : row.ship_date,
              purchase_path: purchase_path,
              commission_dy: commission_dy,
              commission_sell: commission_sell,
              profit_price: profit_price,
            };
          } else if (user && user.id === 4) {
            // 닥터체크 사용자 엑셀 다운 양식 - order_detail_id 삭제
            return {
              order_id_dk: row.order_id,
              // order_detail_id: row.order_detail_id,
              product_id: row.product_id,
              product_name: row.product_name,
              // option_title_dk: "",
              option_title_dk: row.option_title,
              quantity: row.option_id
                ? row.option_quantity * row.quantity
                : row.quantity,
              sales_price: row.total_price,
              unit_sales_price: row.option_price_2,
              // sales_price: "",
              // unit_sales_price: "",
              delivery_company: status.matchingDeliveryCompany[
                row.delivery_company
              ]
                ? status.matchingDeliveryCompany[row.delivery_company]
                : row.delivery_company,
              tracking_number_dk: row.tracking_number,
              recipient: row.name,
              contact: regexPhoneNumber(row.phone),
              phone_dk: regexPhoneNumber(row.phone),
              postal_code: row.postal_code?.toString().padStart(5, "0"),
              address_dk: row.address
                ? row.address +
                  (row.address_detail ? `, ${row.address_detail}` : "")
                : "",
              address_request_dk:
                row.address_request === "배송 시 요청사항을 선택해주세요."
                  ? ""
                  : row.address_request,
              delivery_price_dk: "",
              num_of_tracking_number: "",
              commission_dy: commission_dy,
              commission_sell: commission_sell,
              profit_price: profit_price,
            };
          } else {
            return {
              order_id_dk: row.order_id,
              order_detail_id: row.order_detail_id,
              product_id: row.product_id,
              product_name: row.product_name,
              // option_title_dk: "",
              option_title_dk: row.option_title,
              quantity: row.option_id
                ? row.option_quantity * row.quantity
                : row.quantity,
              sales_price: row.total_price,
              unit_sales_price: row.option_price_2,
              // sales_price: "",
              // unit_sales_price: "",
              delivery_company: status.matchingDeliveryCompany[
                row.delivery_company
              ]
                ? status.matchingDeliveryCompany[row.delivery_company]
                : row.delivery_company,
              tracking_number_dk: row.tracking_number,
              recipient: row.name,
              contact: regexPhoneNumber(row.phone),
              phone_dk: regexPhoneNumber(row.phone),
              postal_code: row.postal_code?.toString().padStart(5, "0"),
              address_dk: row.address
                ? row.address +
                  (row.address_detail ? `, ${row.address_detail}` : "")
                : "",
              address_request_dk:
                row.address_request === "배송 시 요청사항을 선택해주세요."
                  ? ""
                  : row.address_request,
              delivery_price_dk: "",
              num_of_tracking_number: "",
              commission_dy: commission_dy,
              commission_sell: commission_sell,
              profit_price: profit_price,
            };
          }
        });
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          let commission_dy = row.is_cooperate
            ? row?.dy_commission_include
              ? Math.floor(row.total_price * 0.11)
              : 0
            : Math.round(row.total_price * 0.11);
          let commission_sell = row.query
            ? row.is_cooperate
              ? Math.round(
                  row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
                )
              : Math.round(
                  row.total_price * ((row.commission_rate * 1.1) / 100),
                )
            : 0;
          // row.is_cooperate
          // ? Math.round(row.total_price * ((row.cooperate_fee_rate * 1.1) / 100)) :
          // row.is_influencer
          //     ? Math.round(row.total_price * (row.influencer_fee_rate / 100)) : 0
          let profit_price = row.total_price;
          if (row.query) {
            if (row.is_cooperate) {
              profit_price =
                profit_price -
                Math.round(
                  row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
                );
              if (row?.dy_commission_include) {
                profit_price -= Math.floor(row.total_price * 0.11);
              }
            } else {
              profit_price =
                profit_price -
                Math.round(
                  row.total_price * ((row.commission_rate * 1.1) / 100),
                );
              profit_price = profit_price - Math.round(row.total_price * 0.11);
            }
          } else {
            profit_price = profit_price - Math.round(row.total_price * 0.11);
          }
          let purchase_path = "";
          if (row.query) {
            if (row.is_cooperate) {
              purchase_path = "공동구매";
            } else {
              if (row?.is_manual) {
                purchase_path = "전화주문-";
              }
              if (
                row?.influencer_role === "super_admin" ||
                row?.influencer_role === "level_1"
              ) {
                purchase_path += "인플루언서";
              } else {
                purchase_path += "셀러";
              }
            }
          } else if (row?.is_manual) {
            purchase_path = "전화주문";
          } else {
            purchase_path = "검색";
          }
          if (user && (user.id === 1 || user.id === 724)) {
            return {
              order_id: `DY${row.order_id}`,
              order_detail_id: `dy${row.order_detail_id}`,
              payment_created_at: moment(row.payment_created_at).format(
                "YYYY.MM.DD HH:mm",
              ),
              order_detail_status:
                status.matchingOrderStatus[row.order_detail_status],
              product_id: row.product_id,
              product_name: row.product_name,
              option_id: row.option_id,
              option_title: row.option_title,
              quantity: row.quantity,
              total_price: row.total_price,
              price: row.price,
              coupon_discount_price: row.coupon_discount_price,
              created_by_name: row.created_by_name,
              use_point: row.use_point ? "Y" : "N",
              name: row.name,
              phone: row.phone,
              address: row.address
                ? row.address +
                  (row.address_detail ? `, ${row.address_detail}` : "")
                : "",
              address_request:
                row.address_request === "배송 시 요청사항을 선택해주세요."
                  ? ""
                  : row.address_request,
              delivery_company: status.matchingDeliveryCompany[
                row.delivery_company
              ]
                ? status.matchingDeliveryCompany[row.delivery_company]
                : row.delivery_company,
              tracking_number: row.tracking_number,
              ship_date: row.ship_date
                ? moment(row.ship_date).format("YYYY.MM.DD")
                : row.ship_date,
              purchase_path: purchase_path,
              commission_dy: commission_dy,
              commission_sell: commission_sell,
              profit_price: profit_price,
            };
          } else if (user && user.id === 4) {
            // 닥터체크 사용자 엑셀 다운 양식 - order_detail_id 삭제
            return {
              order_id_dk: row.order_id,
              // order_detail_id: row.order_detail_id,
              product_id: row.product_id,
              product_name: row.product_name,
              // option_title_dk: "",
              option_title_dk: row.option_title,
              quantity: row.option_id
                ? row.option_quantity * row.quantity
                : row.quantity,
              sales_price: row.total_price,
              unit_sales_price: row.option_price_2,
              // unit_sales_price: "",
              // sales_price: "",
              delivery_company: status.matchingDeliveryCompany[
                row.delivery_company
              ]
                ? status.matchingDeliveryCompany[row.delivery_company]
                : row.delivery_company,
              tracking_number_dk: row.tracking_number,
              recipient: row.name,
              contact: regexPhoneNumber(row.phone),
              phone_dk: regexPhoneNumber(row.phone),
              postal_code: row.postal_code?.toString().padStart(5, "0"),
              address_dk: row.address
                ? row.address +
                  (row.address_detail ? `, ${row.address_detail}` : "")
                : "",
              address_request_dk:
                row.address_request === "배송 시 요청사항을 선택해주세요."
                  ? ""
                  : row.address_request,
              delivery_price_dk: "",
              num_of_tracking_number: "",
              commission_dy: commission_dy,
              commission_sell: commission_sell,
              profit_price: profit_price,
            };
          } else {
            return {
              order_id_dk: row.order_id,
              order_detail_id: row.order_detail_id,
              product_id: row.product_id,
              product_name: row.product_name,
              // option_title_dk: "",
              option_title_dk: row.option_title,
              quantity: row.quantity,
              sales_price: row.total_price,
              unit_sales_price: row.option_price_2,
              // unit_sales_price: "",
              // sales_price: "",
              delivery_company: status.matchingDeliveryCompany[
                row.delivery_company
              ]
                ? status.matchingDeliveryCompany[row.delivery_company]
                : row.delivery_company,
              tracking_number_dk: row.tracking_number,
              recipient: row.name,
              contact: regexPhoneNumber(row.phone),
              phone_dk: regexPhoneNumber(row.phone),
              postal_code: row.postal_code?.toString().padStart(5, "0"),
              address_dk: row.address
                ? row.address +
                  (row.address_detail ? `, ${row.address_detail}` : "")
                : "",
              address_request_dk:
                row.address_request === "배송 시 요청사항을 선택해주세요."
                  ? ""
                  : row.address_request,
              delivery_price_dk: "",
              num_of_tracking_number: "",
              commission_dy: commission_dy,
              commission_sell: commission_sell,
              profit_price: profit_price,
            };
          }
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      if (user && (user.id === 1 || user.id === 724)) {
        /* empty */
      } else {
        // 닥터체크 사용자일 경우에 첫번째 row에 해당 키 값 바인딩
        let firstRow = {};
        if (user && user.id === 4) {
          firstRow = {
            order_id_dk: "order_id",
            // order_detail_id: "order_detail_id",
            product_id: "product_id",
            product_name: "product_name",
            // option_title_dk: "",
            option_title_dk: "option_title",
            quantity: "quantity",
            sales_price: "sales_price",
            unit_sales_price: "unit_sales_price",
            // unit_sales_price: "",
            // sales_price: "",
            delivery_company: "delivery_company",
            tracking_number_dk: "tracking_number",
            recipient: "recipient",
            contact: "contact",
            phone_dk: "phone",
            postal_code: "postal_code",
            address_dk: "address",
            address_request_dk: "address_request",
            delivery_price_dk: "delivery_price",
            num_of_tracking_number: "num_of_tracking_number",
            commission_dy: "commission_dy",
            commission_sell: "commission_sell",
            profit_price: "profit_price",
          };
        } else {
          firstRow = {
            order_id_dk: "order_id",
            order_detail_id: "order_detail_id",
            product_id: "product_id",
            product_name: "product_name",
            // option_title_dk: "",
            option_title_dk: "option_title",
            quantity: "quantity",
            sales_price: "sales_price",
            unit_sales_price: "unit_sales_price",
            // unit_sales_price: "",
            // sales_price: "",
            delivery_company: "delivery_company",
            tracking_number_dk: "tracking_number",
            recipient: "recipient",
            contact: "contact",
            phone_dk: "phone",
            postal_code: "postal_code",
            address_dk: "address",
            address_request_dk: "address_request",
            delivery_price_dk: "delivery_price",
            num_of_tracking_number: "num_of_tracking_number",
            commission_dy: "commission_dy",
            commission_sell: "commission_sell",
            profit_price: "profit_price",
          };
        }
        excelData = [firstRow].concat(excelData);
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "주문조회");
      // 닥터체크 사용자일 경우, 주문목록 엑셀 다운시, 택배사 시트 추가
      if (user && user.id === 4) {
        const ws_delivery = XLSX.utils.json_to_sheet(
          deliveryCompanyList.map((delivery) => {
            return {
              택배사명: delivery.delivery_company_name,
            };
          }),
        );
        XLSX.utils.book_append_sheet(wb, ws_delivery, "택배사");
      }
      XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_주문조회.xlsx`);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      if (error !== "no data") {
        alert(error);
      }
      console.log("handleExcelDownloadClick edit error", error);
    }
  };

  /**
   * 엑셀 일괄 발송처리 > 업로드된 엑셀 읽기
   */
  const readExcelData = (e) => {
    if (e.target.value !== "") {
      let reader = new FileReader();
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, {
          type: "binary",
          cellDates: true,
          dateNF: "YYYY-MM-DD",
        });
        let sheetNameList = wb.SheetNames;
        let firstSheet = wb.Sheets[sheetNameList[0]];

        let data = XLSX.utils.sheet_to_json(firstSheet, { raw: false });
        setUploadExcelData(data);
        setUploadExcelName(e.target.files[0]?.name);
      };
      reader.readAsBinaryString(e.target.files[0]);
    } else {
      setUploadExcelData([]);
      setUploadExcelName("");
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    setSelectedRowKey([]);
    setSelectedRow([]);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getUserOrderList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[1].value,
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    getUserOrderList("initial");
  };

  const deliveryInfoValidation = () => {
    const validResult = Object.values(editDeliveryInfo).map((deliveryInfo) => {
      if (
        deliveryInfo.delivery_company === null ||
        deliveryInfo.delivery_company === "" ||
        deliveryInfo.tracking_number === null ||
        deliveryInfo.tracking_number === "" ||
        deliveryInfo.ship_date === null ||
        deliveryInfo.ship_date === ""
      ) {
        return false;
      } else {
        return true;
      }
    });
    return validResult.every((valid) => valid);
  };

  const customerDeliveryInfoSetting = () => {
    if (
      selectedRow[0].order_detail_status === "delivery_ready" ||
      selectedRow[0].order_detail_status === "paid"
    ) {
      setCustomerDeliveryInfo({
        id: selectedRow[0].order_id,
        name: selectedRow[0].name,
        address: selectedRow[0].address,
        address_detail: selectedRow[0].address_detail,
        phone: selectedRow[0].phone,
        postal_code: selectedRow[0].postal_code,
      });
      setIsModalOpen(true);
    } else {
      alert(
        "배송지 정보 수정은 발송처리 이전까지만 가능합니다.\n선택하신 주문 건은 발송처리가 진행되어 배송지 수정이 불가능합니다.",
      );
    }
  };

  const handleDeliveryInfoChange = (e) => {
    const { name, value } = e.target;
    setCustomerDeliveryInfo({ ...customerDeliveryInfo, [name]: value });
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("payment_created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 고객 배송지 정보수정 Modal click OK handler
   */
  const handleOk = async () => {
    if (
      customerDeliveryInfo.name === null ||
      customerDeliveryInfo.name === "" ||
      customerDeliveryInfo.address === null ||
      customerDeliveryInfo.address === ""
    ) {
      alert(
        "정보 수정하는데 필요한 값들이 채워지지 않았습니다. 다시 시도해주시길 바랍니다.",
      );
    } else {
      await editCustomerDeliveryInfo();
      setCustomerDeliveryInfo({});
      setSelectedRowKey([]);
      setSelectedRow([]);
      setIsModalOpen(false);
      getUserOrderList();
    }
  };

  /**
   * 고객 배송지 정보수정 Modal click cancel handler
   */
  const handleCancel = () => {
    setCustomerDeliveryInfo({});
    setIsModalOpen(false);
  };

  /**
   * 송장엑셀업로드 Modal click cancel handler
   */
  const handleExcelUploadCancel = () => {
    setUploadExcelDataHeader([]);
    setUploadExcelData([]);
    setUploadExcelName("");
    setIsDeliveryShippingModalOpen(false);
    setValidation(false);
    setUploadExcelDataError([]);
  };

  /**
   * 송장엑셀 재등록
   */
  const handleExcelReUpload = () => {
    setUploadExcelDataHeader([]);
    setUploadExcelData([]);
    setUploadExcelName("");
    setValidation(false);
    setUploadExcelDataError([]);
  };

  const orderDirectlyCancel = async () => {
    setIsLoading(true);
    try {
      // 부분환불처리시 포인트 사용 주문에 관한 부분환불은 추가 로직이 필요함.
      // 회사 입장에서 포인트를 먼저 돌려주는 것이 더 이득임.
      if (selectedRow[0].use_point !== null) {
        const isLastOrderParam = {
          id: selectedRow[0].order_id,
          orderDetailIdList: selectedRowKey,
        };
        const isLastOrderRes = await salesManageApi.isLastOrderByOrderId(
          isLastOrderParam,
        );
        if (isLastOrderRes.result?.length !== 0) {
          throw `해당 주문은 포인트를 사용힌 주문이라 부분 환불이 불가합니다.\n선택한 주문번호와 동일한 모든 것들을 한번에 선택해서 다시 시도하거나 해당 주문번호와 함께 관리자에게 문의해주시길 바랍니다.`;
        }
      }
      let orderDetailIdList = [];
      let totalSum = 0;
      for (const row of selectedRow) {
        orderDetailIdList.push(row.order_detail_id);
        totalSum += row.total_price;
      }
      const param = {
        id: selectedRow[0].order_id,
        orderDetailIdList: orderDetailIdList,
        cancel_request_amount: totalSum,
      };
      console.log("orderDirectlyCancel", param);
      const res = await salesManageApi.refundableOrder(param);
      console.log("refundableOrder", res);
      if (res.code === 200) {
        if (res.result) {
          if (
            window.confirm(
              `주문번호: ${selectedRow[0].order_id} 인 주문건에 대한 환불처리가 가능합니다.\n확인을 눌러 환불처리를 이어서 진행해주세요.`,
            )
          ) {
            setIsCancelModalOpen(true);
          }
        } else {
          alert(
            "해당 주문건을 취소하는데 추가 결제 금액이 발생합니다.\n구매자분께서 추가 결제를 진행할 수 있도록 안내 메시지 작성을 부탁드립니다.",
          );
          setEditCancelReason({
            ...editCancelReason,
            cancel_reason: "추가 결제 금액 발생",
            refund_bank: null,
          });
          setIsCancelRequestModalOpen(true);
        }
      } else {
        throw res.msg;
      }
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("orderDirectlyCancel error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 구매자에게 취소 요청 보내기 Modal click cancel handler
   */
  const handelRequestModalCancel = () => {
    setEditCancelReason({ cancel_reason: null, refund_bank: null });
    setSelectedRow([]);
    setSelectedRowKey([]);
    setIsCancelRequestModalOpen(false);
  };

  /**
   * 구매자에게 취소 요청 보내기 Modal ok handler
   */
  const handleRequestModalOk = async () => {
    setIsLoading(true);
    try {
      const valid = handleSellerCancelValidation();
      if (valid) {
        for (const row of selectedRow) {
          const cancelInfo = {
            order_id: row.order_id,
            order_detail_id: row.order_detail_id,
            order_detail_status: "cancel_request",
            cancel_reason: editCancelReason.cancel_reason,
            cancel_reason_detail:
              editCancelReason.hasOwnProperty("cancel_reason_detail") &&
              editCancelReason.cancel_reason_detail !== null &&
              editCancelReason.cancel_reason_detail !== ""
                ? editCancelReason.cancel_reason_detail
                : "",
            cancel_target: "admin",
            refund_holder: "",
            refund_bank: "",
            refund_account: "",
            updated_by: user.id === 724 ? 1 : user.id,
          };
          const cancelRes = await salesManageApi.orderCancelInfoEdit(
            cancelInfo,
          );
          if (cancelRes.code !== 200) {
            setTimeout(() => {
              handelRequestModalCancel();
            }, 1000);
            if (cancelRes.code === 999) {
              throw cancelRes.msg;
            } else {
              throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
        }
        alert("해당 내용을 성공적으로 요청완료했습니다.");
        getUserOrderList();
      } else {
        throw "필수값이 채워지지 않았거나 원하는 형식과 다릅니다.\n다시 시도해주시길 바랍니다.";
      }
      setIsLoading(false);
      setTimeout(() => {
        handelRequestModalCancel();
      }, 1000);
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleRequestModalOk error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 판매자 직접취소 처리 Modal click cancel handler
   */
  const handelSellerModalCancel = () => {
    setEditCancelReason({ cancel_reason: null, refund_bank: null });
    setSelectedRow([]);
    setSelectedRowKey([]);
    setIsCancelModalOpen(false);
  };

  /**
   * 판매자 직접취소 처리 Modal click ok handler
   */
  const handleSellerModalOk = async () => {
    setIsLoading(true);
    try {
      const valid = handleSellerCancelValidation();
      if (valid) {
        let totalPriceSum = 0;
        let cancelInfoList = [];
        let cancelCouponIdList = [];
        let cancelParam = {};
        let cancelPointParam = {};
        const sellerIdList = [
          ...new Set(selectedRow.map((row) => row.seller_id)),
        ];
        console.log("sellerIdList", sellerIdList);
        for (const sellerId of sellerIdList) {
          const orderBySeller = selectedRow.filter(
            (row) => row.seller_id === sellerId,
          );
          let isLastOrderParam = {
            seller_id: sellerId,
            id: orderBySeller[0].order_id,
            orderDetailIdList: orderBySeller.map(
              (order) => order.order_detail_id,
            ),
          };
          console.log("isLastOrder", isLastOrderParam);
          const isLastOrderRes = await salesManageApi.isLastOrder(
            isLastOrderParam,
          );
          console.log("isLastOrderRes", isLastOrderRes);
          if (isLastOrderRes.code !== 200) {
            throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`;
          }
          for (const order of orderBySeller) {
            totalPriceSum += order.total_price;
            if (order.coupon_id !== null && order.coupon_id !== "ADMIN") {
              cancelCouponIdList.push(order.coupon_id);
            }
            const cancelInfo = {
              order_id: order.order_id,
              order_detail_id: order.order_detail_id,
              order_detail_status: "cancel_complete",
              cancel_reason: editCancelReason.cancel_reason,
              cancel_reason_detail:
                editCancelReason.hasOwnProperty("cancel_reason_detail") &&
                editCancelReason.cancel_reason_detail !== null &&
                editCancelReason.cancel_reason_detail !== ""
                  ? editCancelReason.cancel_reason_detail
                  : "",
              cancel_target: "admin",
              refund_holder:
                editCancelReason.hasOwnProperty("refund_holder") &&
                editCancelReason.refund_holder !== null &&
                editCancelReason.refund_holder !== ""
                  ? editCancelReason.refund_holder
                  : "",
              refund_bank:
                editCancelReason.hasOwnProperty("refund_bank") &&
                editCancelReason.refund_bank !== null &&
                editCancelReason.refund_bank !== ""
                  ? editCancelReason.refund_bank
                  : "",
              refund_account:
                editCancelReason.hasOwnProperty("refund_account") &&
                editCancelReason.refund_account !== null &&
                editCancelReason.refund_account !== ""
                  ? editCancelReason.refund_account
                  : "",
              updated_by: user.id === 724 ? 1 : user.id,
            };
            cancelInfoList.push(cancelInfo);
          }
          if (isLastOrderRes.result?.length === 0) {
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              totalPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum += orderBySeller[0].delivery_price;
            }
          } else {
            let remainPriceSum = 0;
            for (const order of isLastOrderRes.result) {
              remainPriceSum += order.total_price;
            }
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              remainPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum -= orderBySeller[0].delivery_price;
            }
          }
        }
        // 포인트 환급
        if (selectedRow[0].use_point !== null) {
          console.log("마지막 주문입니다!!!", selectedRow[0]);
          cancelPointParam = {
            totalOrder: {
              id: selectedRow[0].order_id,
              order_status: "cancel_complete",
            },
          };
          totalPriceSum -= selectedRow[0].use_point;
        }
        if (selectedRow[0].pay_method === "vbank") {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${editCancelReason.cancel_reason}] ${
              editCancelReason.cancel_reason_detail
                ? editCancelReason.cancel_reason_detail
                : ""
            }`,
            cancel_request_amount: totalPriceSum,
            refund_holder: editCancelReason.refund_holder,
            refund_bank: editCancelReason.refund_bank,
            refund_account: editCancelReason.refund_account,
            userOrderDetailList: selectedRow,
          };
        } else {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${editCancelReason.cancel_reason}] ${
              editCancelReason.cancel_reason_detail
                ? editCancelReason.cancel_reason_detail
                : ""
            }`,
            cancel_request_amount: totalPriceSum,
            // cancelableAmount: row.total_price
            userOrderDetailList: selectedRow,
          };
        }
        console.log("cancelParam", cancelParam);
        const res = await salesManageApi.orderDirectlyCancel(cancelParam);
        if (res.code === 203) {
          console.log(
            "판매자 직접취소처리 cancelCouponIdList",
            cancelCouponIdList,
          );
          if (cancelCouponIdList?.length !== 0) {
            const cancelCoupon = {
              couponIdList: cancelCouponIdList,
              user_coupon_is_available: true,
              user_id: selectedRow[0].created_by,
              created_by: user.id === 724 ? 1 : user.id,
            };
            const cancelCouponRes = await promotionApi.userCouponChangeStatus(
              cancelCoupon,
            );
            console.log("판매자 직접취소처리 cancelCoupon", cancelCouponRes);
            if (cancelCouponRes.code !== 200) {
              throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          // 포인트 환급
          if (Object.keys(cancelPointParam)?.length !== 0) {
            console.log("sdsadad", cancelPointParam);
            const cancelPointRes = await salesManageApi.purchasePointCancel(
              cancelPointParam,
            );
            console.log("포인트 환급 결과 ===", cancelPointRes);
            if (cancelPointRes.code !== 200) {
              throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          for (const cancelInfo of cancelInfoList) {
            const cancelRes = await salesManageApi.orderCancelInfoEdit(
              cancelInfo,
            );
            if (cancelRes.code !== 200) {
              setTimeout(() => {
                handelSellerModalCancel();
              }, 1000);
              if (cancelRes.code === 999) {
                throw cancelRes.msg;
              } else {
                throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
              }
            }
          }
        } else {
          setTimeout(() => {
            handelSellerModalCancel();
          }, 1000);
          throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
        }
        alert("해당 내용이 성공적으로 반영되었습니다.");
        getUserOrderList();
      } else {
        throw "필수값이 채워지지 않았거나 원하는 형식과 다릅니다.\n다시 시도해주시길 바랍니다.";
      }
      setIsLoading(false);
      setTimeout(() => {
        handelSellerModalCancel();
      }, 1000);
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleSellerModalOk error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 취소승인처리 handler
   */
  const handleCancelComplete = async () => {
    setIsLoading(true);
    try {
      if (selectedRow[0].use_point !== null) {
        const isLastOrderParam = {
          id: selectedRow[0].order_id,
          orderDetailIdList: selectedRowKey,
        };
        const isLastOrderRes = await salesManageApi.isLastOrderByOrderId(
          isLastOrderParam,
        );
        if (isLastOrderRes.result?.length !== 0) {
          throw `해당 주문은 포인트를 사용힌 주문이라 부분 환불이 불가합니다.\n선택한 주문번호와 동일한 모든 것들을 한번에 선택해서 다시 시도하거나 해당 주문번호와 함께 관리자에게 문의해주시길 바랍니다.`;
        }
      }
      if (
        window.confirm(
          `${selectedRow[0].order_id} - [${selectedRow[0].cancel_reason}] ${
            selectedRow[0].cancel_reason_detail
          } ${
            selectedRow?.length > 1 ? `외 ${selectedRow?.length - 1}건` : ""
          }  의 사유로 취소 요청된 주문입니다.\n해당 주문 건의 취소요청을 승인하시겠습니까?`,
        )
      ) {
        let cancelInfoList = [];
        let cancelCouponIdList = [];
        let totalPriceSum = 0;
        let cancelParam = {};
        let cancelPointParam = {};
        const sellerIdList = [
          ...new Set(selectedRow.map((row) => row.seller_id)),
        ];
        for (const sellerId of sellerIdList) {
          const orderBySeller = selectedRow.filter(
            (row) => row.seller_id === sellerId,
          );
          let isLastOrderParam = {
            seller_id: sellerId,
            id: orderBySeller[0].order_id,
            orderDetailIdList: orderBySeller.map(
              (order) => order.order_detail_id,
            ),
          };
          const isLastOrderRes = await salesManageApi.isLastOrder(
            isLastOrderParam,
          );
          console.log("isLastOrderRes", isLastOrderRes);
          if (isLastOrderRes.code !== 200) {
            throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`;
          }
          for (const order of orderBySeller) {
            totalPriceSum += order.total_price;
            if (order.coupon_id !== null && order.coupon_id !== "ADMIN") {
              cancelCouponIdList.push(order.coupon_id);
            }
            const cancelInfo = {
              order_id: order.order_id,
              order_detail_id: order.order_detail_id,
              order_detail_status: "cancel_complete",
              cancel_reason: order.cancel_reason,
              cancel_reason_detail: order.cancel_reason_detail,
              cancel_target: order.cancel_target,
              refund_holder:
                order.refund_holder === null ? "" : order.refund_holder,
              refund_bank: order.refund_bank === null ? "" : order.refund_bank,
              refund_account:
                order.refund_account === null ? "" : order.refund_account,
              updated_by: user.id === 724 ? 1 : user.id,
            };
            cancelInfoList.push(cancelInfo);
          }
          if (isLastOrderRes.result?.length === 0) {
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              totalPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum += orderBySeller[0].delivery_price;
            }
          } else {
            let remainPriceSum = 0;
            for (const order of isLastOrderRes.result) {
              remainPriceSum += order.total_price;
            }
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              remainPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum -= orderBySeller[0].delivery_price;
            }
          }
        }
        // 포인트 환급
        if (selectedRow[0].use_point !== null) {
          console.log("마지막 주문입니다!!!", selectedRow[0]);
          cancelPointParam = {
            totalOrder: {
              id: selectedRow[0].order_id,
              order_status: "cancel_complete",
            },
          };
          totalPriceSum -= selectedRow[0].use_point;
        }
        if (selectedRow[0].pay_method === "vbank") {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}`,
            cancel_request_amount: totalPriceSum,
            refund_holder: selectedRow[0].refund_holder,
            refund_bank: selectedRow[0].refund_bank,
            refund_account: selectedRow[0].refund_account,
            userOrderDetailList: selectedRow,
          };
        } else {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}`,
            cancel_request_amount: totalPriceSum,
            userOrderDetailList: selectedRow,
          };
        }
        console.log("cancelParam", cancelParam);
        const res = await salesManageApi.orderDirectlyCancel(cancelParam);
        if (res) {
          console.log("취소 승인처리 cancelCouponIdList", cancelCouponIdList);
          if (cancelCouponIdList?.length !== 0) {
            const cancelCoupon = {
              couponIdList: cancelCouponIdList,
              user_coupon_is_available: true,
              user_id: selectedRow[0].created_by,
              created_by: user.id === 724 ? 1 : user.id,
            };
            const cancelCouponRes = await promotionApi.userCouponChangeStatus(
              cancelCoupon,
            );
            console.log("취소 승인처리 cancelCoupon", cancelCouponRes);
            if (cancelCouponRes.code !== 200) {
              throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          // 포인트 환급
          if (Object.keys(cancelPointParam)?.length !== 0) {
            console.log("sdsadad", cancelPointParam);
            const cancelPointRes = await salesManageApi.purchasePointCancel(
              cancelPointParam,
            );
            console.log("포인트 환급 결과 ===", cancelPointRes);
            if (cancelPointRes.code !== 200) {
              throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          for (const cancelInfo of cancelInfoList) {
            const cancelRes = await salesManageApi.orderCancelInfoEdit(
              cancelInfo,
            );
            if (cancelRes.code !== 200) {
              if (cancelRes.code === 999) {
                throw cancelRes.msg;
              } else {
                throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
              }
            }
          }
        } else {
          throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
        }
        alert("해당 내용이 성공적으로 반영되었습니다.");
        setSelectedRowKey([]);
        setSelectedRow([]);
        getUserOrderList();
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleCancelComplete error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 판매자 직접취소 처리 validation
   */
  const handleSellerCancelValidation = () => {
    if (selectedRow[0].pay_method === "vbank") {
      if (
        editCancelReason.hasOwnProperty("cancel_reason") &&
        editCancelReason.cancel_reason !== null &&
        editCancelReason.cancel_reason !== "" &&
        editCancelReason.hasOwnProperty("refund_holder") &&
        editCancelReason.refund_holder !== null &&
        editCancelReason.refund_holder !== "" &&
        editCancelReason.refund_holder === selectedRow[0].name &&
        editCancelReason.hasOwnProperty("refund_bank") &&
        editCancelReason.refund_bank !== null &&
        editCancelReason.refund_bank !== "" &&
        editCancelReason.hasOwnProperty("refund_account") &&
        editCancelReason.refund_account !== null &&
        editCancelReason.refund_account !== "" &&
        /^(\s|\d)+$/.test(editCancelReason.refund_account)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        editCancelReason.hasOwnProperty("cancel_reason") &&
        editCancelReason.cancel_reason !== null &&
        editCancelReason.cancel_reason !== ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  /**
   * 업로드된 송장 엑셀 유효성 체크
   */
  const handleExcelValidation = async () => {
    setIsLoading(true);
    let isValid = false;
    let dataKeys = [];
    try {
      if (uploadExcelData?.length > 1) {
        let nonExistentRowList = [];
        let orderIdList = [];
        let duplicateOrderIdList = [];
        dataKeys = uploadExcelData.shift();
        setUploadExcelDataHeader(dataKeys);
        for (const data of uploadExcelData) {
          let validValueList = [];
          Object.keys(dataKeys).forEach((key) => {
            switch (key) {
              case "개별상품주문번호":
                if (data.hasOwnProperty(key)) {
                  if (orderIdList.includes(data[key])) {
                    duplicateOrderIdList.push(data[key]);
                    validValueList.push(true);
                  } else {
                    orderIdList.push(data[key].replace("dy", ""));
                    validValueList.push(true);
                  }
                } else {
                  validValueList.push(false);
                }
                break;
              case "택배사":
                if (data.hasOwnProperty(key)) {
                  if (
                    Object.values(status.matchingDeliveryCompany).includes(
                      data[key],
                    )
                  ) {
                    validValueList.push(true);
                  } else {
                    validValueList.push(false);
                  }
                } else {
                  validValueList.push(false);
                }
                break;
              case "발송일":
                if (data.hasOwnProperty(key)) {
                  if (typeof data[key] !== "string") {
                    validValueList.push(false);
                  } else {
                    if (/\d{4}-\d{2}-\d{2}/.test(data[key])) {
                      validValueList.push(true);
                    } else {
                      validValueList.push(false);
                    }
                  }
                }
                break;
              // default:
              //     if (data.hasOwnProperty(key)) {
              //         validValueList.push(true)
              //     } else {
              //         validValueList.push(false)
              //     }
              //     break;
            }
          });
          if (
            !data.hasOwnProperty("택배사") ||
            !data.hasOwnProperty("송장번호")
          ) {
            nonExistentRowList.push(data.__rowNum__ + 1);
          } else {
            if (!validValueList.every((result) => result)) {
              nonExistentRowList.push(data.__rowNum__ + 1);
            }
          }
        }
        if (nonExistentRowList?.length !== 0) {
          throw `${nonExistentRowList.join(
            "행, ",
          )}행의 값이 비어있거나 올바른 형식이 아닙니다.\n올바른 파일을 다시 업로드해주세요`;
        } else if (duplicateOrderIdList?.length !== 0) {
          throw `개별주문번호가 ${duplicateOrderIdList.join(
            ", ",
          )}인 행이 중복되어있습니다.\n확인 후 올바른 파일을 다시 업로드해주세요`;
        } else {
          const res = await salesManageApi.isPossibleUploadTrackingNumber({
            orderDetailIdList: orderIdList,
          });
          if (res.code === 200) {
            if (res.result === 0) {
              setIsLoading(false);
              alert("엑셀 유효성검사가 완료되었습니다.");
              setValidation(true);
              isValid = true;
            } else {
              throw "주문항목들 중 주문상태가 배송준비중이거나 배송중이 아닌 항목들이 존재합니다.\n확인 후 올바른 파일을 다시 업로드해주세요";
            }
          } else {
            throw "해당 주문건들에 대한 주문 상태를 확인하는데 실패하였습니다.\n새로고침 후 다시 업로드 진행해주시길 바랍니다.";
          }
        }
      } else {
        throw "업로드할 데이터가 없습니다.\n데이터를 입력하거나 템플릿 수정 후 다시 업로드해주세요";
      }
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelValidation validation error", e);
      alert(e);
      setTimeout(() => {
        // handleExcelUploadCancel()
        setUploadExcelDataHeader([]);
        setUploadExcelData([]);
        let excelInput = document.getElementById("excelFile");
        excelInput.value = "";
        setUploadExcelName("");
        // setIsDeliveryShippingModalOpen(false)
        setValidation(false);
      }, 1000);
    } finally {
      setIsLoading(false);
      // eslint-disable-next-line no-unsafe-finally
      return { isValid: isValid, dataKeys: dataKeys };
    }
  };

  /**
   * 송장 업로드 양식으로 데이터 바인딩
   * + 상품주문번호에 DY 지우기 (2023.12.11) - ksb
   * @returns {Promise<{}[]>}
   */
  const trackingNumExcelFormat = async (uploadExcelDataHeader) => {
    const dataFormatting = uploadExcelData.map((excelData) => {
      let returnValue = {};
      Object.keys(uploadExcelDataHeader).forEach((key) => {
        if (key === "택배사") {
          returnValue[uploadExcelDataHeader[key]] = Object.keys(
            status.matchingDeliveryCompany,
          ).find(
            (companyKey) =>
              status.matchingDeliveryCompany[companyKey] === excelData[key],
          );
        } else if (key === "발송일") {
          if (excelData[key]) {
            returnValue[uploadExcelDataHeader[key]] = moment(excelData[key]);
          } else {
            returnValue[uploadExcelDataHeader[key]] = moment();
          }
        } else if (key === "개별상품주문번호") {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            "dy",
            "",
          );
        } else if (key === "수취인명") {
          /* empty */
        } else if (key === "상품주문번호") {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            "DY",
            "",
          );
        } else {
          returnValue[uploadExcelDataHeader[key]] = excelData[key];
        }
      });
      returnValue["order_detail_status"] = "delivery_shipping";
      returnValue["updated_by"] = user.id === 724 ? 1 : user.id;
      return returnValue;
    });
    return dataFormatting;
  };

  /**
   * 닥터체크 주문 다운받은 엑셀양식대로 송장업로드 처리 (2023.05.11) - ksb
   * + 세부상품주문번호 체크하는 로직 삭제 처리 (2023.07.21) - ksb
   * @returns {Promise<*[]>}
   */
  const trackingNumExcelFormatForOrderList = async () => {
    try {
      if (uploadExcelData?.length >= 2) {
        let uploadDataList = []; // 서버에 업로드할 데이터
        let uploadDataListForError = []; // 에러 표출 용도
        let orderIdList = [];
        uploadExcelData.shift();

        // order_id 항목 비어있는지 여부 확인
        const existAllOrderId = uploadExcelData.every(
          (data) => data.hasOwnProperty("주문번호") && data["주문번호"].trim(),
        );
        if (!existAllOrderId) {
          throw "업로드하려는 데이터 중에서 주문번호가 없는 항목이 존재합니다.\n업로드하려는 데이터에 해당 항목들에 값이 있는지 다시 한 번 확인하시거나 사용하지 않는 항목은 삭제해서 다시 업로드해주시길 바랍니다.\n해당 오류가 계속해서 발생된다면 관리자에게 문의해주시길 바랍니다.";
        }

        let isValid = false;
        for (const data of uploadExcelData) {
          let uploadDataForError;
          let errorText = "";
          // 이미 처리하지 않은 주문번호에 대한 주문 목록 중, 택배사 및 운송장번호 칸에 값이 있을 때
          if (
            !orderIdList.includes(data["주문번호"]) &&
            data.hasOwnProperty("택배사") &&
            data.hasOwnProperty("운송장번호")
          ) {
            orderIdList.push(data["주문번호"]);
            // 입력한 데이터의 택배사 및 운송장번호가 유효한지 검사
            if (
              Object.values(status.matchingDeliveryCompany).includes(
                data["택배사"].trim(),
              ) &&
              data["운송장번호"].trim()
            ) {
              // 주문번호 및 Plutus 사용자가 판매하는 상세 주문 목록 조회
              const param = {
                order_id: data["주문번호"],
                user_id: user.id === 724 ? 1 : user.id,
              };
              const res = await salesManageApi.searchOrderOne(param);
              if (res.code !== 200) {
                throw "엑셀을 읽는 부분에서 오류가 발생했습니다. 새로고침 후 다시 시도해주시거나 동일한 오류가 발생한다면 관리자에게 문의해주시길 바랍니다.";
              }
              // 상세주문목록별 송장 업로드 data 생성
              for (const orderDetailItem of res.result
                .orderDetailListBySeller) {
                const uploadData = {
                  order_id: data["주문번호"],
                  order_detail_id: orderDetailItem.order_detail_id,
                  delivery_company: Object.keys(
                    status.matchingDeliveryCompany,
                  ).find(
                    (companyKey) =>
                      status.matchingDeliveryCompany[companyKey] ===
                      data["택배사"].trim(),
                  ),
                  tracking_number: data["운송장번호"].trim(),
                  order_detail_status: "delivery_shipping",
                  ship_date: moment(),
                  updated_by: user.id === 724 ? 1 : user.id,
                };
                uploadDataList.push(uploadData);
              }
            } else {
              if (!isValid) {
                isValid = true;
              }
              if (
                !Object.values(status.matchingDeliveryCompany).includes(
                  data["택배사"].trim(),
                )
              ) {
                errorText =
                  "다운받은 엑셀의 택배사 시트에 있는 택배사명과 동일하게 작성해주세요.";
              } else if (!data["운송장번호"].trim()) {
                errorText = "운송장번호 항목이 비어있습니다.";
              } else {
                errorText = "해당 주문은 관리자에게 문의해주시길 바랍니다.";
              }
            }
          } else if (
            orderIdList.includes(data["주문번호"]) &&
            data.hasOwnProperty("택배사") &&
            data.hasOwnProperty("운송장번호")
          ) {
            // 이미 처리한 주문번호에 대한 주문건 중, 택배사 및 운송장번호 칸에 값이 있을 때
            // 입력한 데이터의 택배사 및 운송장번호가 유효한지 검사
            if (
              !Object.values(status.matchingDeliveryCompany).includes(
                data["택배사"].trim(),
              )
            ) {
              if (!isValid) {
                isValid = true;
              }
              errorText =
                "다운받은 엑셀의 택배사 시트에 있는 택배사명과 동일하게 작성해주세요.";
              break;
            } else if (!data["운송장번호"].trim()) {
              if (!isValid) {
                isValid = true;
              }
              errorText = "운송장번호 항목이 비어있습니다.";
              break;
            } else {
              /* empty */
            }
            const currDeliveryCompany = Object.keys(
              status.matchingDeliveryCompany,
            ).find(
              (companyKey) =>
                status.matchingDeliveryCompany[companyKey] ===
                data["택배사"].trim(),
            );
            const findItem = uploadDataList.find(
              (uploadData) => uploadData.order_id === data["주문번호"],
            );
            // 이미 처리된 주문건에 입력된 택배사 및 운송장번호가 동일한지 검사
            if (findItem) {
              if (
                currDeliveryCompany !== findItem.delivery_company ||
                data["운송장번호"].trim() !== findItem.tracking_number
              ) {
                errorText =
                  "동일한 주문번호에는 택배사 및 운송장번호를 동일하게 작성해주세요.";
              }
            }
            if (!isValid && errorText !== "") {
              isValid = true;
            }
          } else {
            if (!isValid) {
              isValid = true;
            }
            if (!data.hasOwnProperty("택배사")) {
              errorText = "택배사 항목이 비어있습니다.";
            } else if (!data.hasOwnProperty("운송장번호")) {
              errorText = "운송장번호 항목이 비어있습니다.";
            } else {
              errorText = "해당 주문은 관리자에게 문의해주시길 바랍니다.";
            }
          }

          uploadDataForError = {
            order_id: data["주문번호"],
            // order_detail_id: data["세부상품주문번호"],
            error: errorText,
          };
          const findIdx = uploadDataListForError.findIndex(
            (uploadDate) => uploadDate.order_id === uploadDataForError.order_id,
          );
          if (findIdx < 0) {
            uploadDataListForError.push(uploadDataForError);
          } else {
            if (
              uploadDataListForError[findIdx].error === "" &&
              uploadDataForError.error !== ""
            ) {
              uploadDataListForError[findIdx] = uploadDataForError;
            }
          }
        }

        // 업로드할 주문 목록 주문 상태 확인
        const param = {
          orderIdList: orderIdList,
          created_by: user.id === 724 ? 1 : user.id,
        };
        const res = await salesManageApi.isPossibleUploadTrackingNumber(param);
        if (res.code !== 200) {
          throw "해당 주문건들에 대한 주문 상태를 확인하는데 실패하였습니다.\n새로고침 후 다시 업로드 진행해주시길 바랍니다.";
        } else {
          if (res.result !== 0) {
            throw "주문항목들 중 주문상태가 배송준비중이거나 배송중이 아닌 항목들이 존재합니다.\n새로고침 후 다시 주문 목록을 다운받으셔서 진행해주시길 바랍니다.\n계속해서 같은 오류가 발생한다면 해당 엑셀과 함께 관리자에게 문의해주시길 바랍니다.";
          }
        }

        setUploadExcelDataError(uploadDataListForError);

        return isValid ? [] : uploadDataList;
      } else {
        throw "업로드할 데이터가 없거나 다운받은 양식과 다른 형식입니다.\n다운받은 양식 그대로 택배사와 송장번호만 작성해서 업로드해주시길 바랍니다.";
      }
    } catch (e) {
      setIsLoading(false);
      alert(e);
      const timer = setTimeout(() => {
        // handleExcelUploadCancel()
        setUploadExcelDataHeader([]);
        setUploadExcelData([]);
        let excelInput = document.getElementById("excelFile");
        excelInput.value = "";
        setUploadExcelName("");
        // setIsDeliveryShippingModalOpen(false)
        setValidation(false);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  };

  /**
   * 송장 엑셀 데이터 formatting
   * + 엑셀 일괄 발송처리 > 등록하기 버튼 클릭 함수 (2023.08.01) - ksb
   */
  const handleExcelUpload = async () => {
    setIsLoading(true);
    let dataFormatting;
    if (user && user.id === 4) {
      dataFormatting = await trackingNumExcelFormatForOrderList();
    } else {
      const validationResult = await handleExcelValidation();
      if (validationResult.isValid) {
        dataFormatting = await trackingNumExcelFormat(
          validationResult.dataKeys,
        );
      }
    }

    // 유효성 검사한 엑셀 데이터 DB에 저장
    if (dataFormatting?.length) {
      try {
        const res = await salesManageApi.orderTrackingNumRegister({
          userOrderDetailDTOList: dataFormatting,
        });
        if (res.code === 200 && res.result) {
          const orderIdSet = new Set(
            res.result.map((deliveryInfo) => deliveryInfo.order_id),
          );
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: dataFormatting.map((deliveryInfo) =>
              deliveryInfo.order_detail_id.replace("dy", ""),
            ),
            order_status: "delivery_shipping",
          };
          await sendKakaoAlert(orderParam);
          alert("해당 내용이 성공적으로 반영되었습니다.");
          getUserOrderList();
          const timer = setTimeout(() => {
            handleExcelUploadCancel();
          }, 1000);
          return () => {
            clearTimeout(timer);
          };
        } else if (res.code === 999 || res.code === 405) {
          alert(res.msg);
          if (user && user.id === 4) {
            getUserOrderList();
            const timer = setTimeout(() => {
              handleExcelUploadCancel();
            }, 1000);
            return () => {
              clearTimeout(timer);
            };
          }
        } else {
          alert(
            "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
          );
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setError(error);
        console.log("handleExcelUpload edit error", error);
      }
    }
    setIsLoading(false);
  };

  /**
   * Post Code 입력하기 (다음 주소 api)
   * @param data
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }

    if (fullAddress?.length > 0) {
      setCustomerDeliveryInfo({
        ...customerDeliveryInfo,
        postal_code: data.zonecode,
        address: fullAddress,
      });
    }
    setIsPostalCodeModalOpen(false); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  };

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false);
    setOrderDetail({});
  };

  const disabledDeliveryReady = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every((row) => row.order_detail_status === "paid");
    }
  };

  const disabledDeliveryShipping = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      return !selectedRow.every(
        (row) =>
          row.order_detail_status === "delivery_ready" ||
          row.order_detail_status === "delivery_shipping",
      );
    }
  };

  const disabledCancelComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
            validList.push(false);
          } else {
            if (
              row.order_detail_status === "cancel_request" &&
              row.cancel_target !== "admin"
            ) {
              validList.push(true);
            } else {
              validList.push(false);
            }
          }
        } else {
          if (row.order_id !== orderId) {
            validList.push(false);
          } else {
            if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
              validList.push(false);
            } else {
              if (
                row.order_detail_status === "cancel_request" &&
                row.cancel_target !== "admin"
              ) {
                validList.push(true);
              } else {
                validList.push(false);
              }
            }
          }
        }
      }
      return !validList.every((result) => result);
    }
  };

  const disabledAdminCancelComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
            validList.push(false);
          } else {
            if (
              row.order_detail_status === "paid" ||
              row.order_detail_status === "delivery_ready"
            ) {
              validList.push(true);
            } else {
              validList.push(false);
            }
          }
        } else {
          if (row.order_id !== orderId) {
            validList.push(false);
          } else {
            if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
              validList.push(false);
            } else {
              if (
                row.order_detail_status === "paid" ||
                row.order_detail_status === "delivery_ready"
              ) {
                validList.push(true);
              } else {
                validList.push(false);
              }
            }
          }
        }
      }
      return !validList.every((result) => result);
    }
  };

  const disabledValidationBtn = () => {
    if (uploadExcelData?.length !== 0 && !validation) {
      return false;
    } else {
      return true;
    }
  };

  // 전화번호 자동 정규식 처리
  const regexPhoneNumber = (target) => {
    return target
      ?.replace(/[^0-9]/g, "")
      .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  };

  const handleExcelWithDelivery = async () => {
    getUserOrderList();
    if (
      confirm(`${selectedRow?.length}개의 주문을 발주확인 처리 하시겠습니까?`)
    ) {
      changeOrderStatus("delivery_ready");
      handleExcelDownloadClick();
    }
  };

  return (
    <>
      <ContentHeaderComponent title="발주확인/발송관리" />
      <div className="product-register-wrap">
        {/* 발주 확인 Quick-Button */}
        <SearchQuickMenu
          searchOptions={searchOptions}
          setSearchOptions={setSearchOptions}
          setDateType={setDateType}
          getUserOrderList={getUserOrderList}
        />
        {/*주문검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: "left" }}
            >
              {searchDateItems.map((item, idx) => (
                <Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Row align={"middle"} style={{ marginTop: 10, gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="구매경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value) || e.target.value === "") {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      });
                    }
                  }}
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문검색목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              주문목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
        >
          <div>
            <Button
              className="order-status-change-button"
              disabled={disabledDeliveryReady()}
              onClick={handleExcelWithDelivery}
            >
              <img
                style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
              />
              발주확인 처리
            </Button>
            <Button
              className="order-status-change-button"
              disabled={disabledDeliveryReady()}
              onClick={() => changeOrderStatus("delivery_ready")}
            >
              발주확인
            </Button>
            <Button
              className="order-status-change-button"
              disabled={disabledDeliveryShipping()}
              onClick={() => changeOrderStatus("delivery_shipping")}
            >
              발송처리
            </Button>
            <Button
              className="order-status-change-button"
              onClick={() => setIsDeliveryShippingModalOpen(true)}
            >
              엑셀 일괄 발송처리
            </Button>
            <Button
              className="order-status-change-button"
              disabled={disabledAdminCancelComplete()}
              onClick={() => orderDirectlyCancel()}
            >
              판매자 직접취소 처리
            </Button>
          </div>
          {user?.role === "super_admin" && (
            <div>
              <Button
                className="order-status-change-button"
                onClick={() =>
                  history.push("/salesManage/purchaseComfirmation")
                }
              >
                구매확정 후 취소처리 바로가기
                <img
                  style={{ height: 14.2, width: 14.5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
                />
              </Button>
            </div>
          )}
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            // tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
        <div
          className="product-register-border-box"
          style={{
            backgroundColor: "#f8f9fd",
            height: "fit-content",
            padding: "15px 25px",
            borderTop: 0,
          }}
        >
          <Form.Item
            className="order-bottom-form-item center-label"
            label="주문관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledDeliveryReady()}
                onClick={() => changeOrderStatus("delivery_ready")}
              >
                발주확인
              </Button>
              <Button
                className="order-status-change-button"
                disabled={selectedRowKey?.length !== 1}
                onClick={customerDeliveryInfoSetting}
              >
                고객 배송지 정보수정
              </Button>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
          <Form.Item
            className="order-bottom-form-item"
            // label="취소관리"
            label="배송관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledDeliveryShipping()}
                onClick={() => changeOrderStatus("delivery_shipping")}
              >
                발송처리
              </Button>
              <Button
                className="order-status-change-button"
                onClick={() => setIsDeliveryShippingModalOpen(true)}
              >
                엑셀 일괄 발송처리
              </Button>
            </Row>
            <div style={{ marginTop: 10 }}>
              * 배송사 및 송장번호 입력 후, 발송처리를 눌러주세요.
            </div>
          </Form.Item>
          <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
          <Form.Item
            className="order-bottom-form-item"
            label="반품교환관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledAdminCancelComplete()}
                onClick={() => orderDirectlyCancel()}
              >
                판매자 직접취소 처리
              </Button>
              {/*<Button className="order-status-change-button" disabled={disabledCancelComplete()}*/}
              {/*        onClick={() => handleCancelComplete()}>취소 승인처리</Button>*/}
            </Row>
            <div style={{ marginTop: 10 }}>
              * 같은 주문번호에 한해서만 다건처리가 가능합니다. 혹은 하나씩
              선택해주세요.
            </div>
          </Form.Item>
        </div>

        {/*고객배송지정보수정Modal*/}
        {selectedRow?.length !== 0 &&
        Object.keys(customerDeliveryInfo)?.length !== 0 ? (
          <Modal
            title="고객 배송지 정보수정"
            visible={isModalOpen}
            centered={true}
            cancelText={<span>취소</span>}
            okText={<span>정보 수정</span>}
            onOk={handleOk}
            onCancel={handleCancel}
            // width={"80%"}
          >
            <Form.Item
              label="수령자명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="name"
                value={customerDeliveryInfo.name}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="연락처"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="phone"
                value={customerDeliveryInfo.phone}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="우편번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Row justify={"space-between"} style={{ width: "100%" }}>
                <Col span={10}>
                  <Input
                    name="postal_code"
                    value={customerDeliveryInfo.postal_code}
                    onChange={handleDeliveryInfoChange}
                  />
                </Col>
                <Col span={"auto"}>
                  <Button onClick={() => setIsPostalCodeModalOpen(true)}>
                    우편번호 검색
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              label="주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="address"
                value={customerDeliveryInfo.address}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="상세주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="address_detail"
                value={customerDeliveryInfo.address_detail}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
          </Modal>
        ) : null}

        {/*우편번호검색Modal*/}
        {isPostalCodeModalOpen && (
          <Modal
            className="order-postal-code-modal"
            visible={isPostalCodeModalOpen}
            onCancel={() => setIsPostalCodeModalOpen(false)}
            footer={null}
          >
            <DaumPostcodeEmbed
              style={{
                height: "450px",
              }}
              submitMode={false}
              onComplete={handlePostCode}
            />
          </Modal>
        )}

        {/*송장 엑셀 일괄 발송처리Modal*/}
        {/*{isDeliveryShippingModalOpen && (*/}
        {/*    <Modal*/}
        {/*        className="order-tracking-number-modal"*/}
        {/*        title="엑셀 일괄 발송처리"*/}
        {/*        visible={isDeliveryShippingModalOpen}*/}
        {/*        onCancel={handleExcelUploadCancel}*/}
        {/*        footer={[*/}
        {/*            <Button key="back" onClick={handleExcelUploadCancel} loading={isLoading}*/}
        {/*                    disabled={isLoading}>돌아가기</Button>,*/}
        {/*            <Button type="primary" loading={isLoading} disabled={disabledValidationBtn()}*/}
        {/*                    onClick={handleExcelValidation}>유효성검사하기</Button>,*/}
        {/*            <Button key="submit" type="primary" loading={isLoading} disabled={!validation}*/}
        {/*                    onClick={handleExcelUpload}>자료업로드하기</Button>,*/}
        {/*        ]}*/}
        {/*    >*/}
        {/*        <p>* 업로드할 엑셀파일을 선택해주세요(.xlsx)</p>*/}
        {/*        <p>* 일괄발송처리 전용 파일 양식을 통한 등록도 가능합니다.</p>*/}
        {/*        <Button className="excel-template-download-btn"*/}
        {/*                href={`${process.env.REACT_APP_HOST}/assets/files/TrackingNumber_Template.xlsx`}>일괄발송처리*/}
        {/*            양식 다운 ></Button>*/}
        {/*        <input disabled={validation} type={"file"} id='excelFile' onChange={readExcelData}/>*/}
        {/*    </Modal>*/}
        {/*)}*/}
        {isDeliveryShippingModalOpen && (
          <Modal
            className="excel-delivery-modal"
            title="엑셀 일괄 발송처리"
            visible={isDeliveryShippingModalOpen}
            onCancel={handleExcelUploadCancel}
            footer={null}
          >
            <ExcelUploadBody
              uploadExcelName={uploadExcelName}
              uploadExcelDataError={uploadExcelDataError}
              handleExcelUpload={handleExcelUpload}
              validation={validation}
              readExcelData={readExcelData}
              handleExcelReUpload={handleExcelReUpload}
              loading={isLoading}
            />
          </Modal>
        )}

        {/*판매자 직접취소 처리*/}
        {isCancelModalOpen && (
          <Modal
            title="선택건 판매취소"
            visible={isCancelModalOpen}
            onCancel={handelSellerModalCancel}
            onOk={handleSellerModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>선택건 판매취소</span>}
            confirmLoading={isLoading}
            width={"50%"}
          >
            <Form.Item
              label="판매 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                placeholder="선택"
                value={editCancelReason.cancel_reason}
                onChange={(value) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    cancel_reason: value,
                  })
                }
                style={{ width: 250, textAlign: "left" }}
              >
                {cancelReasonItems.map((item, idx) => (
                  <Option key={`order_cancel_reason_${idx}`} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                value={editCancelReason.cancel_reason_detail}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
            {selectedRow?.length !== 0 &&
              selectedRow[0].pay_method === "vbank" && (
                <>
                  <Form.Item
                    label="예금주"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    required
                  >
                    <Input
                      placeholder="주문자명과 동일한 예금주명을 입력해주세요"
                      name="refund_holder"
                      value={editCancelReason.refund_holder}
                      onChange={(e) =>
                        setEditCancelReason({
                          ...editCancelReason,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label="환불 은행"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    required
                  >
                    <Select
                      placeholder="환불 은행을 선택해주세요"
                      value={editCancelReason.refund_bank}
                      onChange={(value) =>
                        setEditCancelReason({
                          ...editCancelReason,
                          refund_bank: value,
                        })
                      }
                    >
                      {bankCodeItems.map((item, idx) => (
                        <Option key={`bank_code_${idx}`} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="계좌번호"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    required
                  >
                    <Input
                      placeholder={`"-"없이 계좌번호 숫자를 입력해주세요`}
                      name="refund_account"
                      value={editCancelReason.refund_account}
                      onChange={(e) =>
                        setEditCancelReason({
                          ...editCancelReason,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                </>
              )}
          </Modal>
        )}

        {/*구매자에게 취소 요청 보내기*/}
        {isCancelRequestModalOpen && (
          <Modal
            title="선택건 판매취소요청"
            visible={isCancelRequestModalOpen}
            onCancel={handelRequestModalCancel}
            onOk={handleRequestModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            width={"50%"}
          >
            <Form.Item
              label="취소 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="cancel_reason"
                value={editCancelReason.cancel_reason}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                value={editCancelReason.cancel_reason_detail}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
          </Modal>
        )}

        {/*주문 상세 페이지*/}
        {isOrderModalOpen && (
          <Modal
            title="상품주문정보 조회"
            wrapClassName="order-detail-modal-wrap"
            visible={isOrderModalOpen}
            centered={true}
            onCancel={handleOrderDetailModalCancel}
            footer={null}
            width="60%"
          >
            <OrderDetailComponent
              orderDetail={orderDetail}
              handleOrderDetailModalCancel={handleOrderDetailModalCancel}
              getUserOrderList={getUserOrderList}
            />
          </Modal>
        )}
      </div>
    </>
  );
};
export default OrderSearchComponent;
